export default __webpack_public_path__ + "static/media/appstore-apple.593721ba.png";